export const BOOKING_TYPES = {
  // New detailed booking types
  AIRPORT_TRANSFER: 'airport_transfer',
  AIRPORT_HOURLY: 'airport_hourly',
  CITY_POINT_TO_POINT: 'city_point_to_point',
  CITY_HOURLY: 'city_hourly'
};

// Geofencing boundaries for Colombo/Negombo area
export const CITY_GEOFENCE = {
  // Rectangle boundaries for Colombo/Negombo area
  bounds: {
    north: 7.3000,  // Northern boundary
    south: 6.8000,  // Southern boundary  
    east: 80.0000,  // Eastern boundary
    west: 79.8000   // Western boundary
  },
  // Main city centers for reference
  centers: [
    { name: 'Colombo', lat: 6.9271, lng: 79.8612 },
    { name: 'Negombo', lat: 7.2083, lng: 79.8358 }
  ]
};

export const SERVICE_TYPES = {
  AIRPORT: 'airport',
  CITY: 'city'
};

// UPDATED: Added WebXPay payment method
export const PAYMENT_METHODS = {
  CARD: 'card',
  PAYPAL: 'paypal',
  GPAY: 'gpay',
  WEBXPAY: 'webxpay'
};

export const VEHICLE_CLASSES = {
  ECONOMY: 'economy',
  STANDARD: 'standard',
  VAN: 'van',
  MINIBUS: 'minibus'
};

export const BOOKING_STEPS = {
  VEHICLE: 0,
  EXTRAS: 1,
  PASSENGER: 2,
  PAYMENT: 3
};

export const PAGES = {
  HOME: 'home',
  LOADING: 'loading',
  SEARCH: 'search',
  EXTRAS: 'extras',
  PASSENGER: 'passenger',
  PAYMENT: 'payment',
  CONFIRMATION: 'confirmation',
  MANAGE_BOOKING: 'manage_booking',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILED: 'payment_failed',
  LOGIN: 'login',
  REGISTER: 'register',
  PROFILE: 'profile',
  PROFILE_SETTINGS: 'profile_settings',
  BOOKING_HISTORY: 'booking_history',
  EMAIL_VERIFICATION: 'email_verification',
  AUTH_CALLBACK: 'auth_callback',
  FAQ: 'faq',
  CONTACT: 'contact'
};

export const API_CONFIG = {
  // Required runtime configuration - do NOT rely on defaults when dockerizing.
  BASE_URL: process.env.REACT_APP_API_URL,
  TENANT_CODE: process.env.REACT_APP_TENANT_CODE,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || ''
};

// Auth-related constants
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data'
};

export const USER_ROLES = {
  CUSTOMER: 'customer',
  ADMIN: 'admin'
};

export const AUTH_PROVIDERS = {
  LOCAL: 'local',
  GOOGLE: 'google'
};

// 🆕 NEW: WebXPay configuration
export const WEBXPAY_CONFIG = {
  SUPPORTED_CURRENCIES: ['LKR', 'USD'],
  CARD_TYPES: {
    VISA_MASTER: 'visa_master',
    AMEX: 'amex',
    CUP: 'cup'
  },
  DEFAULT_CARD_TYPE: 'visa_master'
};

// Payment method display configurations
export const PAYMENT_METHOD_CONFIG = {
  [PAYMENT_METHODS.CARD]: {
    name: 'Credit/Debit Card',
    icon: '💳',
    description: 'Visa, Mastercard, Amex',
    badges: [
      { label: 'VISA', color: 'bg-blue-600' },
      { label: 'MC', color: 'bg-red-600' },
      { label: 'AMEX', color: 'bg-blue-800' }
    ]
  },
  [PAYMENT_METHODS.WEBXPAY]: {
    name: 'WebXPay',
    icon: '🏦',
    description: 'Local Sri Lankan payment gateway',
    badges: [
      { label: 'LKR', color: 'bg-green-600' },
      { label: 'SECURE', color: 'bg-purple-600' }
    ]
  },
  [PAYMENT_METHODS.PAYPAL]: {
    name: 'PayPal',
    icon: '🅿️',
    description: 'Pay with PayPal account',
    badges: [
      { label: 'PayPal', color: 'bg-blue-600' }
    ]
  },
  [PAYMENT_METHODS.GPAY]: {
    name: 'Google Pay',
    icon: 'G',
    description: 'Quick payment with Google',
    badges: [
      { label: 'GPay', color: 'bg-blue-500' }
    ]
  }
};

export const COUNTRY_CODES = [
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', minLength: 9, maxLength: 9 },
  { code: '+1', country: 'USA/Canada', flag: '🇺🇸', minLength: 10, maxLength: 10 },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧', minLength: 10, maxLength: 10 },
  { code: '+91', country: 'India', flag: '🇮🇳', minLength: 10, maxLength: 10 },
  { code: '+61', country: 'Australia', flag: '🇦🇺', minLength: 9, maxLength: 9 },
  { code: '+49', country: 'Germany', flag: '🇩🇪', minLength: 10, maxLength: 11 },
  { code: '+33', country: 'France', flag: '🇫🇷', minLength: 9, maxLength: 9 },
  { code: '+39', country: 'Italy', flag: '🇮🇹', minLength: 9, maxLength: 10 },
  { code: '+34', country: 'Spain', flag: '🇪🇸', minLength: 9, maxLength: 9 },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', minLength: 9, maxLength: 9 },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', minLength: 9, maxLength: 9 },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', minLength: 9, maxLength: 9 },
  { code: '+43', country: 'Austria', flag: '🇦🇹', minLength: 10, maxLength: 10 },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', minLength: 9, maxLength: 9 },
  { code: '+47', country: 'Norway', flag: '🇳🇴', minLength: 8, maxLength: 8 },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', minLength: 8, maxLength: 8 },
  { code: '+358', country: 'Finland', flag: '🇫🇮', minLength: 9, maxLength: 10 },
  { code: '+48', country: 'Poland', flag: '🇵🇱', minLength: 9, maxLength: 9 },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', minLength: 9, maxLength: 9 },
  { code: '+30', country: 'Greece', flag: '🇬🇷', minLength: 10, maxLength: 10 },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', minLength: 9, maxLength: 9 },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', minLength: 9, maxLength: 9 },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', minLength: 9, maxLength: 9 },
  { code: '+40', country: 'Romania', flag: '🇷🇴', minLength: 9, maxLength: 9 },
  { code: '+7', country: 'Russia', flag: '🇷🇺', minLength: 10, maxLength: 10 },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦', minLength: 9, maxLength: 9 },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', minLength: 10, maxLength: 10 },
  { code: '+972', country: 'Israel', flag: '🇮🇱', minLength: 9, maxLength: 9 },
  { code: '+971', country: 'UAE', flag: '🇦🇪', minLength: 9, maxLength: 9 },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', minLength: 9, maxLength: 9 },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', minLength: 8, maxLength: 8 },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', minLength: 8, maxLength: 8 },
  { code: '+968', country: 'Oman', flag: '🇴🇲', minLength: 8, maxLength: 8 },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', minLength: 8, maxLength: 8 },
  { code: '+962', country: 'Jordan', flag: '🇯🇴', minLength: 9, maxLength: 9 },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧', minLength: 7, maxLength: 8 },
  { code: '+20', country: 'Egypt', flag: '🇪🇬', minLength: 10, maxLength: 10 },
  { code: '+27', country: 'South Africa', flag: '🇿🇦', minLength: 9, maxLength: 9 },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', minLength: 10, maxLength: 10 },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', minLength: 9, maxLength: 9 },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿', minLength: 9, maxLength: 9 },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', minLength: 9, maxLength: 9 },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', minLength: 9, maxLength: 9 },
  { code: '+212', country: 'Morocco', flag: '🇲🇦', minLength: 9, maxLength: 9 },
  { code: '+86', country: 'China', flag: '🇨🇳', minLength: 11, maxLength: 11 },
  { code: '+81', country: 'Japan', flag: '🇯🇵', minLength: 10, maxLength: 10 },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', minLength: 9, maxLength: 10 },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', minLength: 8, maxLength: 8 },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', minLength: 9, maxLength: 9 },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', minLength: 8, maxLength: 8 },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', minLength: 9, maxLength: 10 },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', minLength: 9, maxLength: 9 },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', minLength: 9, maxLength: 10 },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', minLength: 10, maxLength: 12 },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', minLength: 10, maxLength: 10 },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', minLength: 10, maxLength: 10 },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', minLength: 10, maxLength: 10 },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', minLength: 10, maxLength: 10 },
  { code: '+960', country: 'Maldives', flag: '🇲🇻', minLength: 7, maxLength: 7 },
  { code: '+55', country: 'Brazil', flag: '🇧🇷', minLength: 10, maxLength: 11 },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', minLength: 10, maxLength: 10 },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', minLength: 10, maxLength: 10 },
  { code: '+56', country: 'Chile', flag: '🇨🇱', minLength: 9, maxLength: 9 },
  { code: '+57', country: 'Colombia', flag: '🇨🇴', minLength: 10, maxLength: 10 },
  { code: '+51', country: 'Peru', flag: '🇵🇪', minLength: 9, maxLength: 9 },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', minLength: 10, maxLength: 10 },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', minLength: 9, maxLength: 10 },
  { code: '+679', country: 'Fiji', flag: '🇫🇯', minLength: 7, maxLength: 7 },
];